import React from "react";
import useScrollToTop from "./../../../hooks/useScollToTop";

import useMediaAlbumsAdmin from "./hooks/useMediaAlbumsAdmin";

import MediaAlbumsHero from "./components/MediaAlbumsHero";
import MediaAlbumsStatsGrid from "./components/MediaAlbumsStatsGrid";
import MediaAlbumsFiltersPanel from "./components/MediaAlbumsFiltersPanel";
import MediaAlbumsList from "./components/MediaAlbumsList";
import MediaAlbumFormDrawer from "./components/MediaAlbumFormDrawer";
import MediaAlbumDeleteDrawer from "./components/MediaAlbumDeleteDrawer";
import MediaAlbumPhotosDrawer from "./components/MediaAlbumPhotosDrawer";
import MediaAlbumMediaPickerDrawer from "./components/MediaAlbumMediaPickerDrawer";

export default function MediaAlbumsAdmin() {
  useScrollToTop();

  const albums = useMediaAlbumsAdmin();

  return (
    <div className="mx-auto w-full max-w-[1600px] px-1 pb-10 sm:px-2 lg:px-0">
      <MediaAlbumsHero
        stats={albums.stats}
        loading={albums.loading}
        onCreate={albums.openCreate}
      />

      {albums.notice ? (
        <div className="mt-5 rounded-[1.5rem] border border-emerald-200 bg-emerald-50 px-5 py-4 text-sm font-bold text-emerald-800 shadow-sm dark:border-emerald-500/20 dark:bg-emerald-500/10 dark:text-emerald-300">
          {albums.notice}
        </div>
      ) : null}

      {albums.error ? (
        <div className="mt-5 rounded-[1.5rem] border border-rose-200 bg-rose-50 px-5 py-4 text-sm font-bold text-rose-800 shadow-sm dark:border-rose-500/20 dark:bg-rose-500/10 dark:text-rose-300">
          {albums.error}
        </div>
      ) : null}

      <MediaAlbumsStatsGrid stats={albums.stats} loading={albums.loading} />

      <MediaAlbumsFiltersPanel
        q={albums.q}
        activeFilter={albums.activeFilter}
        homeFilter={albums.homeFilter}
        limit={albums.limit}
        onChangeQ={albums.setQ}
        onChangeActiveFilter={albums.changeActiveFilter}
        onChangeHomeFilter={albums.changeHomeFilter}
        onChangeLimit={albums.changeLimit}
        onSubmit={albums.onSubmitSearch}
        onReset={albums.resetFilters}
        onRefresh={albums.fetchData}
        loading={albums.loading}
      />

      <MediaAlbumsList
        items={albums.items}
        loading={albums.loading}
        total={albums.total}
        page={albums.page}
        totalPages={albums.totalPages}
        actionId={albums.actionId}
        onPageChange={albums.setPage}
        onEdit={albums.openEdit}
        onToggleActive={albums.onToggleActive}
        onTogglePublic={albums.onTogglePublic}
        onToggleHome={albums.onToggleHome}
        onManagePhotos={albums.openPhotosDrawer}
        onAskDelete={albums.openDelete}
      />

      <MediaAlbumFormDrawer
        open={albums.formOpen}
        form={albums.form}
        fieldErrors={albums.fieldErrors}
        saving={albums.saving}
        isEdit={!!albums.currentId}
        onClose={albums.closeForm}
        onChange={albums.updateFormField}
        onSave={albums.onSave}
      />

      <MediaAlbumDeleteDrawer
        open={!!albums.deleteItem}
        item={albums.deleteItem}
        deleting={albums.deleting}
        onClose={albums.closeDelete}
        onConfirm={albums.onDelete}
      />

      <MediaAlbumPhotosDrawer
        open={!!albums.photosAlbum}
        album={albums.photosAlbum}
        actionId={albums.photosActionId}
        onClose={albums.closePhotosDrawer}
        onOpenMediaPicker={albums.openMediaPicker}
        onSetCover={albums.onSetCover}
        onToggleItemVisible={albums.onToggleItemVisible}
        onRemoveItem={albums.onRemoveAlbumItem}
        onUpdateItem={albums.onUpdateAlbumItem}
        onReorderItems={albums.onReorderAlbumItems}
        onRefresh={albums.refreshPhotosAlbum}
      />

      <MediaAlbumMediaPickerDrawer
        open={albums.mediaPickerOpen}
        onClose={albums.closeMediaPicker}
        onConfirm={albums.handleAddSelectedMedias}
      />
    </div>
  );
}